<template>
    <b-card bg-variant="dark" text-variant="light" class="autoresponderTemplateVariables" :title="$t('title')"
            v-if="Object.keys(templateVariables).length > 0">
        <b-form-group v-for="(v, k) in templateVariables" :key="k" class="variable" :label="k">

            <b-input :value="variables[k]" @input="setVariable(k, $event)"
                :type='v.format ? "datetime-local" : "text"'
                :placeholder="v.defaultValue"></b-input>
        </b-form-group>
        <b-button @click="doClear">{{$t('clear')}}</b-button>
    </b-card>
</template>

<script>
export default {
  name: 'autoresponderTemplateVariables',
  i18nOptions: { keyPrefix: 'settings.autoresponders.templateVariables' },
  props: {
    template: String,
    value: String
  },
  methods: {
    doClear() {
      this.$emit('input', '');
    },
    setVariable(k, v) {
      let x = this.variables;
      x[k] = v;
      console.log('set var', x);
      const newValue = Object.keys(x).reduce((o, k) => {
        o.push(`${k}:${x[k]}`);
        return o;
      }, []).join('\n');
      this.$emit('input', newValue);
      console.log('variables set', newValue);
    }
  },
  computed: {
    templateVariables() {
      return [...this.template.matchAll(/\{\$([a-z][a-z0-9_]*)(?: *\(([^}]*?)\))?(?: *:([^}]*?))?\}/gi)].reduce((o, m) => {
        console.log('templvar', m);
        let defaultValue = '';
        let format = '';
        if (m[2] !== undefined) {
          defaultValue = m[2];
        }
        if (m[3] !== undefined) {
          format = m[3];
        }
        return Object.assign(o, { [m[1]]: { defaultValue, format } });
      }, {});
    },
    variables() {
      return this.value.split(/\n/).filter(v => v).reduce((o, v) => {
        const f = v.split(':');
        return Object.assign(o, { [f[0]]: f[1] });
      }, {});
    }
  }
};
</script>

<style scoped>

</style>
